export function formatCost(cost: number | null) {
  if (!cost) return "-"

  if (cost < 0.01) {
    return "0.01"
  }
  return `${cost.toFixed(2)}`
}
